/* eslint-disable class-methods-use-this */
import {
    post,
    get,
    put,
    _delete,
  } from '@/lin/plugins/axios'
  
  const _baseUri = 'plugin/api/lottery/'
  
  class Lottery {
    async reset(id, clear, type = 0) {
      const data = {
        id, 
        clear,
        type,
      }
      const res = await _delete(`${_baseUri}reset`, data)
      return res
    }
  }
  
  export default new Lottery()
  